/**
 * @description 埋点基础策略 - 集中配置管理方案
 * @author zcq
 * @date 2025-04-18
 */

import { IBurialPointStrategy } from '../types';

// write by cursor
/**
 * 基础埋点策略类，提供通用功能
 */
export abstract class BaseBurialPointStrategy implements IBurialPointStrategy {
  protected initialized = false;
  protected maxRetries = 3;
  protected retryDelay = 1000; // 毫秒

  abstract init(): Promise<void>;
  abstract sendEvent(eventType: string, eventName: string, params?: Record<string, any>): void;

  // 添加重试机制
  protected async withRetry<T>(operation: () => Promise<T>, errorMessage: string): Promise<T | null> {
    let currentRetry = 0;

    while (currentRetry <= this.maxRetries) {
      try {
        return await operation();
      } catch (error) {
        currentRetry++;
        console.error(`${errorMessage} (尝试 ${currentRetry}/${this.maxRetries + 1}):`, error);

        if (currentRetry <= this.maxRetries) {
          // 等待延迟时间后重试
          await new Promise(resolve => setTimeout(resolve, this.retryDelay * currentRetry));
        } else {
          return null;
        }
      }
    }

    return null;
  }
}
